import type { ProjectState } from './types'
import { DEFAULT_PAGE_ROWS } from 'core/constants'

export const state: ProjectState = {
  projects: [],
  selectedRows: DEFAULT_PAGE_ROWS,
  currentPage: 1,
  selectedProjectIds: [],
}
